module.exports = __webpack_public_path__ + "img/petstairs00.22b75c0f.jpg";